export const ADVISOR_CLIENT_RECEIVED = 'ADVISOR_CLIENT_RECEIVED'
export const ADVISOR_CLIENT_PATCHED = 'ADVISOR_CLIENT_PATCHED'
export const ADVISOR_CLIENT_RESTOREPOINT = 'ADVISOR_CLIENT_RESTOREPOINT'
export const ADVISOR_CLIENT_CLOSED = 'ADVISOR_CLIENT_CLOSED'